module.exports = __webpack_public_path__ + "static/img-self-defense-c81999135eac0b9e6ecd77305f99e188.webp";